export const poolParameters = [
  {
    id: 'alkalinity',
    name: 'Alcalinidad',
    unit: 'ppm',
    icon: 'ri-scales-3-line',
    optimalRange: { min: 80, max: 120 },
    warningRange: { min: 70, max: 140 },
    currentValue: 95,
    status: 'optimal' // optimal, warning, critical
  },
  {
    id: 'ph',
    name: 'pH',
    unit: '',
    icon: 'ri-test-tube-line',
    optimalRange: { min: 7.2, max: 7.4 },
    warningRange: { min: 7.0, max: 7.6 },
    currentValue: 7.3,
    status: 'optimal'
  },
  {
    id: 'stabilizer',
    name: 'Estabilizante',
    unit: 'ppm',
    icon: 'ri-shield-line',
    optimalRange: { min: 25, max: 50 },
    warningRange: { min: 20, max: 60 },
    currentValue: 35,
    status: 'optimal'
  },
  {
    id: 'freeChlorine',
    name: 'Cloro Libre',
    unit: 'ppm',
    icon: 'ri-drop-line',
    optimalRange: { min: 1, max: 2 },
    warningRange: { min: 0.5, max: 3 },
    currentValue: 1.5,
    status: 'optimal'
  },
  {
    id: 'combinedChlorine',
    name: 'Cloro Combinado',
    unit: 'ppm',
    icon: 'ri-alert-line',
    optimalRange: { min: 0, max: 0 },
    warningRange: { min: 0, max: 0.5 },
    currentValue: 0.1,
    status: 'warning'
  },
  {
    id: 'hardness',
    name: 'Dureza',
    unit: 'ppm',
    icon: 'ri-crystal-line',
    optimalRange: { min: 150, max: 400 },
    warningRange: { min: 100, max: 500 },
    currentValue: 220,
    status: 'optimal'
  },
  {
    id: 'phosphates',
    name: 'Fosfatos',
    unit: 'ppb',
    icon: 'ri-plant-line',
    optimalRange: { min: 0, max: 125 },
    warningRange: { min: 0, max: 200 },
    currentValue: 80,
    status: 'optimal'
  },
  {
    id: 'salt',
    name: 'Cloro Salino',
    unit: 'ppm',
    icon: 'ri-drop-line',
    optimalRange: { min: 4, max: 5 },
    warningRange: { min: 3, max: 6 },
    currentValue: 4.5,
    status: 'optimal'
  },
  {
    id: 'salinity',
    name: 'Salinidad Total',
    unit: 'ppm',
    icon: 'ri-contrast-drop-line',
    optimalRange: { min: 2700, max: 3400 },
    warningRange: { min: 2500, max: 3600 },
    currentValue: 3100,
    status: 'optimal'
  }
];

// Parámetros del dispositivo Scuba3s
export const scuba3sParameters = [
  {
    id: 'scuba_alkalinity',
    name: 'Alcalinidad-m T',
    unit: 'mg/L CaCO3',
    icon: 'ri-scales-3-line',
    optimalRange: { min: 5, max: 300 },
    warningRange: { min: 0, max: 350 },
    currentValue: 120,
    status: 'optimal'
  },
  {
    id: 'scuba_bromine',
    name: 'Bromo T',
    unit: 'mg/L Br2',
    icon: 'ri-flask-line',
    optimalRange: { min: 0.2, max: 13.5 },
    warningRange: { min: 0, max: 15 },
    currentValue: 3.5,
    status: 'optimal'
  },
  {
    id: 'scuba_chlorine',
    name: 'Cloro T',
    unit: 'mg/L Cl2',
    icon: 'ri-drop-line',
    optimalRange: { min: 0.1, max: 6.0 },
    warningRange: { min: 0, max: 7 },
    currentValue: 2.5,
    status: 'optimal'
  },
  {
    id: 'scuba_copper',
    name: 'Cobre T',
    unit: 'mg/L Cu',
    icon: 'ri-copper-coin-line',
    optimalRange: { min: 0.1, max: 5 },
    warningRange: { min: 0, max: 6 },
    currentValue: 0.8,
    status: 'optimal'
  },
  {
    id: 'scuba_cya',
    name: 'CyA T',
    unit: 'mg/L CyA',
    icon: 'ri-shield-line',
    optimalRange: { min: 20, max: 120 },
    warningRange: { min: 15, max: 140 },
    currentValue: 45,
    status: 'optimal'
  },
  {
    id: 'scuba_hardness',
    name: 'Dureza Calcium (B) T',
    unit: 'mg/L CaCO3',
    icon: 'ri-crystal-line',
    optimalRange: { min: 50, max: 500 },
    warningRange: { min: 30, max: 550 },
    currentValue: 250,
    status: 'optimal'
  },
  {
    id: 'scuba_phosphate',
    name: 'Fosfato LR T',
    unit: 'mg/L PO4',
    icon: 'ri-plant-line',
    optimalRange: { min: 0.06, max: 3.0 },
    warningRange: { min: 0, max: 3.5 },
    currentValue: 0.5,
    status: 'optimal'
  },
  {
    id: 'scuba_oxygen',
    name: 'Oxígeno Activo T',
    unit: 'mg/L O2',
    icon: 'ri-bubble-chart-line',
    optimalRange: { min: 0.2, max: 10 },
    warningRange: { min: 0, max: 12 },
    currentValue: 5.2,
    status: 'optimal'
  },
  {
    id: 'scuba_ph',
    name: 'pH T',
    unit: 'pH',
    icon: 'ri-test-tube-line',
    optimalRange: { min: 6.5, max: 8.4 },
    warningRange: { min: 6.0, max: 9.0 },
    currentValue: 7.2,
    status: 'optimal'
  }
];

// Productos químicos utilizados
export const chemicalProducts = [
  { id: 'chlorine', name: 'Cloro', unit: 'kg', icon: 'ri-drop-fill' },
  { id: 'chlorineGas', name: 'Cloro Gaseoso', unit: 'kg', icon: 'ri-cloud-line' },
  { id: 'saltProduct', name: 'Sal', unit: 'kg', icon: 'ri-contrast-drop-line' },
  { id: 'calcium', name: 'Calcio', unit: 'kg', icon: 'ri-crystal-line' },
  { id: 'bromineProduct', name: 'Bromo', unit: 'kg', icon: 'ri-flask-line' },
  { id: 'aluminum', name: 'Aluminio', unit: 'kg', icon: 'ri-copper-diamond-line' },
  { id: 'iron', name: 'Hierro', unit: 'kg', icon: 'ri-hammer-line' },
  { id: 'ammonium', name: 'Amonio', unit: 'kg', icon: 'ri-bubble-chart-fill' },
  { id: 'phosphatesProduct', name: 'Fosfatos', unit: 'kg', icon: 'ri-plant-line' },
  { id: 'other', name: 'Otros', unit: 'kg', icon: 'ri-add-circle-line' }
];

export const historicalData = [
  {
    date: '2024-01-15',
    time: '08:00',
    alkalinity: 92,
    ph: 7.2,
    stabilizer: 32,
    freeChlorine: 1.8,
    combinedChlorine: 0.0,
    hardness: 210,
    phosphates: 75,
    salt: 4.3,
    technician: 'María García'
  },
  {
    date: '2024-01-14',
    time: '08:00',
    alkalinity: 88,
    ph: 7.4,
    stabilizer: 35,
    freeChlorine: 1.6,
    combinedChlorine: 0.1,
    hardness: 215,
    phosphates: 82,
    salt: 4.1,
    technician: 'Carlos López'
  },
  {
    date: '2024-01-13',
    time: '08:00',
    alkalinity: 95,
    ph: 7.3,
    stabilizer: 38,
    freeChlorine: 1.9,
    combinedChlorine: 0.0,
    hardness: 225,
    phosphates: 78,
    salt: 4.4,
    technician: 'María García'
  },
  {
    date: '2024-01-12',
    time: '08:00',
    alkalinity: 91,
    ph: 7.1,
    stabilizer: 33,
    freeChlorine: 1.4,
    combinedChlorine: 0.2,
    hardness: 205,
    phosphates: 85,
    salt: 4.0,
    technician: 'Ana Martín'
  },
  {
    date: '2024-01-11',
    time: '08:00',
    alkalinity: 89,
    ph: 7.5,
    stabilizer: 36,
    freeChlorine: 2.0,
    combinedChlorine: 0.0,
    hardness: 220,
    phosphates: 72,
    salt: 4.5,
    technician: 'Carlos López'
  }
];

export const alerts = [
  {
    id: 1,
    type: 'warning',
    parameter: 'combinedChlorine',
    message: 'El cloro combinado está ligeramente elevado. Se recomienda verificar el sistema de filtración.',
    timestamp: '2024-01-15 08:30'
  }
];

export const reports = [
  {
    id: 1,
    name: 'Reporte Semanal Enero',
    type: 'Semanal',
    period: '08-15 Enero 2024',
    format: 'PDF',
    generatedDate: '2024-01-15',
    size: '2.3 MB'
  },
  {
    id: 2,
    name: 'Análisis Mensual Diciembre',
    type: 'Mensual',
    period: 'Diciembre 2023',
    format: 'Excel',
    generatedDate: '2024-01-02',
    size: '1.8 MB'
  },
  {
    id: 3,
    name: 'Datos Exportados CSV',
    type: 'Personalizado',
    period: '01-10 Enero 2024',
    format: 'CSV',
    generatedDate: '2024-01-10',
    size: '156 KB'
  }
];

export const scheduledReports = [
  {
    id: 1,
    name: 'Reporte Diario Automático',
    frequency: 'Diario',
    nextExecution: '2024-01-16 09:00',
    recipients: ['admin@piscina.com', 'tecnico@piscina.com'],
    active: true
  },
  {
    id: 2,
    name: 'Resumen Semanal',
    frequency: 'Semanal',
    nextExecution: '2024-01-21 10:00',
    recipients: ['gerencia@piscina.com'],
    active: true
  }
];